import React from 'react';
import { Block, Label, Value } from './styledComponents';

export type FeatureType = {
  label: string;
  value: string | number | React.ReactNode;
};

export type Props = FeatureType & {
  desktopSmallView?: boolean;
};

const Feature = ({ label, value, desktopSmallView }: Props) => (
  <Block desktopSmallView={desktopSmallView}>
    <Label>{label}</Label>
    <Value>{value}</Value>
  </Block>
);

export default Feature;
